module.exports = __webpack_public_path__ + "static/banner_x.8fbc7969.png";